var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _rect9, _circle2, _rect10, _circle3, _rect11, _circle4, _circle5, _circle6, _circle7, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path4, _rect34, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefThumbFleetMakeup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 30 372 314",
    width: 348,
    height: 294,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 386,
    height: 348,
    rx: 0,
    fill: "#EBF4E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 37,
    width: 73,
    height: 292,
    rx: 3,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50 Q26.05 55.95 32 57 Q26.05 58.05 25 64 Q23.95 58.05 18 57 Q23.95 55.95 25 50Z",
    fill: "#2DA44E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 45.5 Q35.525 48.475 38.5 49 Q35.525 49.525 35 52.5 Q34.475 49.525 31.5 49 Q34.475 48.475 35 45.5Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 60 Q37.45 62.55 40 63 Q37.45 63.45 37 66 Q36.55 63.45 34 63 Q36.55 62.55 37 60Z",
    fill: "#45B39D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 81,
    width: 59,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 94,
    width: 59,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 107,
    width: 59,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 48,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 301,
    width: 63,
    height: 22,
    rx: 2,
    fill: "#E3EFD3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 40,
    width: 38,
    height: 34,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 50,
    r: 4.5,
    fill: "#45B39D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 40,
    width: 38,
    height: 34,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 50,
    r: 4.5,
    fill: "#8DC63F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 40,
    width: 38,
    height: 34,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 50,
    r: 4.5,
    fill: "#45B39D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 40,
    width: 38,
    height: 34,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 50,
    r: 4.5,
    fill: "#8DC63F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 124,
    r: 24,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 9,
    strokeDasharray: "37.70 150.80",
    strokeDashoffset: 0,
    transform: "rotate(-90 136 124)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 124,
    r: 24,
    fill: "none",
    stroke: "#45B39D",
    strokeWidth: 9,
    strokeDasharray: "87.46 150.80",
    strokeDashoffset: -37.7,
    transform: "rotate(-90 136 124)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 124,
    r: 24,
    fill: "none",
    stroke: "#E3EFD3",
    strokeWidth: 9,
    strokeDasharray: "25.64 150.80",
    strokeDashoffset: -125.16,
    transform: "rotate(-90 136 124)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 108,
    width: 90,
    height: 5,
    rx: 1,
    fill: "#FFFFFF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 121,
    width: 90,
    height: 5,
    rx: 1,
    fill: "#FFFFFF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 134,
    width: 68,
    height: 5,
    rx: 1,
    fill: "#FFFFFF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 170,
    width: 82,
    height: 152,
    rx: 3,
    fill: "#FFFFFF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 170,
    width: 82,
    height: 152,
    rx: 3,
    fill: "#FFFFFF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 272,
    width: 6,
    height: 44,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 264,
    width: 6,
    height: 52,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 131.6,
    y: 268,
    width: 6,
    height: 48,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 258,
    width: 6,
    height: 58,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 149.2,
    y: 262,
    width: 6,
    height: 54,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 254,
    width: 6,
    height: 62,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 260,
    width: 6,
    height: 56,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 175.60000000000002,
    y: 256,
    width: 6,
    height: 60,
    rx: 0,
    fill: "#6CC3B1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 302,
    width: 6,
    height: 14,
    rx: 0,
    fill: "#8DC63F"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 210.8,
    y: 304,
    width: 6,
    height: 12,
    rx: 0,
    fill: "#8DC63F"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 300,
    width: 6,
    height: 16,
    rx: 0,
    fill: "#8DC63F"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 228.4,
    y: 306,
    width: 6,
    height: 10,
    rx: 0,
    fill: "#8DC63F"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 237.2,
    y: 303,
    width: 6,
    height: 13,
    rx: 0,
    fill: "#8DC63F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 305,
    width: 6,
    height: 11,
    rx: 0,
    fill: "#8DC63F"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 254.8,
    y: 301,
    width: 6,
    height: 15,
    rx: 0,
    fill: "#8DC63F"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 286,
    width: 6,
    height: 30,
    rx: 0,
    fill: "#8DC63F"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 38,
    width: 68,
    height: 44,
    rx: 3,
    fill: "#DDEDC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304 44 l-5 3 l5 3Z",
    fill: "#DDEDC8"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 94,
    width: 68,
    height: 170,
    rx: 3,
    fill: "#DDEDC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304 100 l-5 3 l5 3Z",
    fill: "#DDEDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefThumbFleetMakeup);
export default __webpack_public_path__ + "static/media/brief-thumb-fleet-makeup.77324b1929a7a43032c43b374ca9a333.svg";
export { ForwardRef as ReactComponent };